import { Component, Input, OnChanges, SimpleChange, SimpleChanges, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { StoredFile } from '../../model/file';
import { FileTree } from '../file.tree/file.tree';

@Component({
  selector: 'file-explorer',
  templateUrl: './file.explorer.html',
  styleUrls: ['./file.explorer.scss']
})
export class FileExplorer implements OnInit, OnChanges {

    @Input('show-searchbar')
    showSearchBar: boolean = false;

    @Input('show-folder-tree')
    showFolderTree: boolean = false;

    @Input('resource')
    resource: String = "";

    @Input('fileTypes')
    fileTypes: any = {};    //Map<string, string> = new Map<string, string>();

    @Output('open')
    onOpen: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('select')
    onSelect: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @ViewChild('searchBox', {static: false})
    searchBox: ElementRef;

    @ViewChild('fileTree', {static: false, read: FileTree})
    fileTree: FileTree;

    @ViewChild('splitPanes', {static: false})
    splitPanes: ElementRef;


  folders: StoredFile[] = [];

  selected_folder_id: number;
  
  files: StoredFile[] = [];

  path: string = '';

  ngOnInit() {
    // console.log('showFolderTree ', this.showFolderTree);
    // console.log('showSearchBar', this.showSearchBar);
    // console.log("fileTypes", this.fileTypes);
    //this.sizeHeight();
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('changes to file explorer: ', changes);
    //if (changes.showSearchBar) {
      //this.sizeHeight();
    //}
  }

  /*private sizeHeight() {
    console.log("resizing");
    if (this.searchBox && this.splitPanes) {
      let sh = this.searchBox.nativeElement.height;
      console.log("height", this.searchBox.nativeElement.height);
      
      this.splitPanes.nativeElement.style.height = sh + 'px';
    }
  }*/

  searchResults(event: any) {
    if (event && event.hits) {
      this.folders = [];
      this.files = [];
      for(let hit of event.hits) {
          if (hit.size > 0) {
            this.files.push(new StoredFile().read(hit));
          } else {
            this.folders.push(new StoredFile().read(hit));
          }
      }
    }
  }

  folderSelected(event: StoredFile) {
      if (!event) return;
      let p = event.path || '';
      if (p.length) {
          if (p.startsWith('/')) p = p.substring(1);
          if (p.length) p += '/';
      }
      p += event.filename;

      this.path = p;
      this.selected_folder_id = event.id;
  }

  treeChanged(event: StoredFile) {
    if (this.fileTree) {
      this.fileTree.reload();
    }
  }

  select(file: StoredFile) {
    if (file && file.guid && this.onSelect.observers.length) {
      this.onSelect.emit(file);
    }
  }

  open(file: StoredFile) {
    if (file && file.guid && this.onOpen.observers.length) {
      this.onOpen.emit(file);
    }
  }
  
}
